/** *******************************************************************************************************************
 * Copyright (c) 2020 - Fundação CERTI
 * All rights reserved.
 ******************************************************************************************************************* */

import React, { useState, useEffect } from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CloseIcon from '@material-ui/icons/Close';
import {
  Dialog, TextField, Checkbox, Button, AppBar, Toolbar, IconButton,
  Typography, CircularProgress, DialogContentText, DialogContent,
} from '@material-ui/core';
import useStyles from './styles';

const SamplersPanel = ({
  comapanyName, samplerUsers, onClose, onConfirm, open, isLoading,
}) => {
  const [changedUsers, setUser] = useState([]);
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;
  const classes = useStyles();

  useEffect(() => {
    setUser(JSON.parse(JSON.stringify(samplerUsers)));
  }, [samplerUsers])

  const handleClose = () => {
    onClose();
  };

  const handleConfirm = () => {
    const changedSamplers = changedUsers.filter(
      (item) => samplerUsers
        .find((i) => i.id === item.id)
        .value !== item.value,
    );
    onConfirm(changedSamplers);
  };

  const handleChange = (e, value, reason, selected) => {
    switch (reason) {
      case 'select-option':
        changedUsers.map((user) => {
          if (user.id === selected.option.id) {
            console.log('user');
            console.log(user);
            user.value = true;
          }
          return user;
        });
        break;
      case 'clear':
        changedUsers.map((user) => {
          user.value = false;
          return user;
        });
        break;
      case 'remove-option':
        changedUsers.map((user) => {
          if (user.id === selected.option.id) {
            user.value = false;
          }
          return user;
        });
        break;
      default:
        console.log(`unknown option ${reason}`);
        break;
    }
    setUser(changedUsers);
  };

  return (
    <Dialog fullScreen open={open} onClose={handleClose}>
      <AppBar className={classes.appBar}>
        <Toolbar>
          <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
            <CloseIcon />
          </IconButton>
          <Typography variant="h6" className={classes.title}>
            Selecionar coletores
            </Typography>
          <Button autoFocus color="inherit" onClick={handleConfirm}>
            SALVAR
            </Button>
        </Toolbar>
      </AppBar>
      <DialogContent>
        <div className={classes.form}>
          <div className={classes.text}>
            <DialogContentText>
              Profissionais autorizados a fazer coleta na empresa <b>{comapanyName}</b>
            </DialogContentText>
          </div>

          {isLoading ? (
            <CircularProgress />
          ) : (
              <Autocomplete
                onChange={handleChange}
                multiple
                id="add-samplers-users"
                options={samplerUsers}
                defaultValue={samplerUsers.filter((item) => item.value !== false)}
                disableCloseOnSelect
                getOptionLabel={(option) => option.fullname}
                renderOption={(option, { selected }) => (
                  <>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 8 }}
                      checked={selected}
                    />
                    {option.fullname}
                  </>
                )}
                style={{
                  width: 500, position: 'center',
                }}
                renderInput={(params) => (
                  <TextField {...params} variant="outlined" label="Coletores" placeholder="Coletores" />
                )}
              />
            )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SamplersPanel;
